import React, { HTMLAttributes, MouseEventHandler } from 'react';
import classNames from 'classnames';
import styles from './Alert.styles';
import { createUseStyles } from 'src/theming';

const useStyles = createUseStyles(styles);

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Objet permettant de modifier les classes utilisées par le composant
   */
  classes?: any;

  /**
   * Nom(s) de classe(s) CSS à inclure dans le composant racine
   */
  className?: string;

  /**
   * Couleur de l'alerte
   */
  color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | string;

  /**
   * Si un callback est défini, une croix s'affiche et cette fonction est
   * appelée lorsque l'utilisateur clique dessus
   */
  onClose?: MouseEventHandler;
}

const Alert: React.FC<AlertProps> = (props) => {
  const { children, className, color, onClose, ...otherProps } = props;

  const classes = useStyles({ color });

  return (
    <div className={classNames(classes.root, className)} {...otherProps}>
      {children}
      {onClose && <span onClick={onClose}>X</span>}
    </div>
  );
};

/**
 * @summary Permet d'afficher des messages contextuels
 */
export default Alert;
